import InputFormDefault from "../../components/Input/InputForm";
import { InputCPFForm as InputCPFFormDefault } from "../../components/Input/InputCPFForm";
import { InputPhoneForm as InputPhoneFormDefault } from "../../components/Input/InputPhoneForm";
import Colors from "../../template/Colors";
import { withStyles } from "@material-ui/core";
import SelectFormDefault from "../../components/Select/Select";
import InputDateFormDefault from "../../components/Input/InputDateForm";
import InputTimeFormDefault from "../../components/Input/InputTimeForm";
import { InputCNPJ } from "../Input/InputCNPJ";

const styleInput = {
    root: {
      width: '100%',
    },
    rootWithLabel: {
        marginTop: '0 !important',
    },
    label: {
        color: Colors.primary.main,
        lineHeight: '14px',
        transform: 'none',
        transition: 'none',
        position: 'relative',
        fontSize: '1rem',
        paddingLeft: '4px',
    },
    input: {
        border: 0,
        borderRadius: 8,
        height: 19,
        paddingLeft: '8px',
        backgroundColor: '#F2F2F2',
        fontSize: '14px',
        color: Colors.commons.gray9,
        '&:focus': {
            borderColor: Colors.primary.main
        }
    },
  
    inputError: {
        border: '1px solid ' + Colors.commons.red,
        borderRadius: 8,
        height: 17,
        paddingLeft: '8px',
        backgroundColor: '#F2F2F2',
        fontSize: '14px',
        fontFamily: "Poppins",
        color:  Colors.commons.gray9,
    },
    inputType: {},
    inputMultiline: {
        fontSize: '14px',
        paddingTop: '5px',
        paddingBottom: '10px',
    }
};

const styleDate = {
    input: {
        padding: '4px 0px 0px 22px',
        textAlign: 'center',
        color: Colors.commons.gray7,
        fontFamily: 'Poppins !important',
    },
    icon: {
        '& button': {
            padding: 0,
            marginRight: 5,
            width: '24px',
            height: '24px',
            color: Colors.commons.gray7,
        },

        '& span.material-icons': {
            position: 'absolute',
            marginTop:0,
        },
        '& svg': {
            fontSize: '18px',
        }
    },
    label: {
        color: Colors.commons.secondary,
        fontFamily: 'Poppins !important',
        fontSize: '12px',
        transform: 'none',
        transition: 'none',
        marginTop: 0,
    },
    date: {
        borderWidth: 0.5,
        border: 0,
        borderRadius: '8px',
        fontSize: '14px',
        alignItems: 'center',
        color: Colors.commons.gray7,
        lineHeight: '150%',
        height: '32px',
        backgroundColor: Colors.commons.gray2,
    },
    dateOutlined: {
        boxSizing: "border-box",
        paddingLeft: 6
    },
    error: {
        borderWidth: 0.5,
        borderStyle: 'solid',
        borderColor: `${Colors.commons.red} !important`
    }
}

const styleSelect = {
    root: {
        width: '100%',
        fontFamily: 'Poppins!important',
        
        '&.width-auto': {
            width: 'auto',
        }
    },
    select: {
        fontSize: '14px',
        fontFamily: 'Poppins!important',
        border: '0',
        minHeight: '6px',
        height: '18px',
        color: Colors.commons.gray7,
        backgroundColor: Colors.commons.gray2,
        margin: '0 0 0 0',
        padding: '9px 0px 5px 10px',
        borderRadius: '100px',

        '&:focus': {
            borderRadius: '100px',
            borderColor: Colors.primary.main,
            color: Colors.commons.gray7,
            backgroundColor: Colors.commons.gray2,
        },


        '& div:focus': {
            backgroundColor: 'transparent',
        },
        
        '&.hide-borders': {
            borderColor: 'transparent',
            paddingRight: 30,
            lineHeight: 'normal'
        },
        
        '&.primary': {
            color: Colors.primary.main
        }
    },
    inputLabel: {
        fontFamily: 'Poppins!important',
        color: Colors.primary.main,
        lineHeight: '15px',
        transition: 'none',
        transform: 'none',
    },
    menuItem: {
        lineHeight: '17px',
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingTop: '5px',
        color: Colors.commons.fontColor,
        paddingBottom: '5px',
        fontFamily: 'Poppins!important',    
    },

    itemLabel: {
        paddingRight: '10px',
        color: Colors.commons.fontColor,
        fontFamily: 'Poppins!important',    
    },

    icon: {
        color: Colors.commons.gray7,
        top: 'calc(50% - 12px)',
        fontSize: '24px',
        borderRadius: '50%',
        right: 6 
    },
    status: {
        display: 'inline-box',
        marginTop: '1px',
        width: '15px',
        minWidth: '15px',
        height: '15px',
        borderRadius: '50%'
    },
    statusLabel: {
        marginLeft: '5px',
        marginTop: '2px',
        fontFamily: 'Poppins!important',    
    },
    itemSelectedStatus: {
        display: 'inline-flex',
        alignItems: 'center',
        width: '65%'
    }
  };

const styleTime = {
    input: {
        padding: '4px 0px 0px 22px',
        textAlign: 'center',
        color: Colors.commons.gray7,
        fontFamily: 'Poppins !important',
        fontSize: 14
    },
    icon: {
        '& button': {
            padding: 0,
            marginRight: 5,
            width: '24px',
            height: '24px',
            backgroundColor: Colors.primary.main,
            color: Colors.commons.gray7,

            "&:disabled": {
                backgroundColor: Colors.commons.gray7
            }

        },

        '& span.material-icons': {
            position: 'absolute',
            marginTop:0,
        },
        '& svg': {
            fontSize: '18px',
        }
    },
    label: {
        color: Colors.commons.gray7,
        fontSize: '12px',
        transform: 'none',
        transition: 'none',
        marginTop: 0,
        fontFamily: 'Poppins !important',
    },
    date: {
        borderWidth: 0.5,
        border: 0,
        borderRadius: 8,
        fontSize: '14px',
        alignItems: 'center',
        color: Colors.commons.gray7,
        lineHeight: '150%',
        height: '32px',
        backgroundColor: Colors.commons.gray2,
        fontFamily: 'Poppins !important',
    },
    error: {
        borderWidth: 0.5,
        borderStyle: 'solid',
        borderColor: `${Colors.commons.red} !important`
    }
};
    
  export const InputForm = withStyles(styleInput)(InputFormDefault);
  
  export const InputPhoneForm = withStyles(styleInput)(InputPhoneFormDefault);

  export const InputCPFForm = withStyles(styleInput)(InputCPFFormDefault);

  export const InputCNPJForm = withStyles(styleInput)(InputCNPJ);

  export const InputDateForm = withStyles(styleDate)(InputDateFormDefault)

  export const InputTimeForm = withStyles(styleTime)(InputTimeFormDefault)

  export const SelectForm = withStyles(styleSelect)(SelectFormDefault);
